<template>
    <div>
        <SingleOption
            class="impediment-option__container"
            v-model="innerValue.selected"
            :type="innerValue.type"
            :label="innerValue.option"
            :selected="innerValue.selected"
            :name="`option-${innerValue.impedimentId}`"
            :id="innerValue.id"
            :disabled="disabled || haveNotChildrenSelected"
            @radio-input="$emit('radio-input', innerValue)"
            @checkbox-input="$emit('checkbox-input', innerValue)"
        />
        <SingleOption
            v-for="child in innerValue.children"
            :key="child.id"
            class="impediment-child-option__container"
            v-model="child.selected"
            :type="child.type"
            :label="child.option"
            :selected="child.selected"
            :name="`child-${child.parentId}`"
            :id="`${child.impedimentId}-${child.id}`"
            :disabled="disabled"
            @radio-input="childRadioChange(child)"
            @checkbox-input="childCheckChange"
        />
    </div>
</template>

<script>
import SingleOption from './SingleOption.vue';

export default {
    name: 'OptionsTree',
    components: {
        SingleOption,
    },
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        innerValue: null,
    }),
    methods: {
        childRadioChange(child) {            
            const anyChildSelected = this.innerValue.children.reduce((acum, x) => acum || x.selected, false);
            this.innerValue.selected = anyChildSelected;

            if (!child.selected) return;

            this.innerValue.children
                .filter(x => x.id != child.id)
                .forEach(childToDisable => {
                    const childIndex = this.innerValue.children.indexOf(childToDisable);
                    this.innerValue.children[childIndex].selected = false;
                });
        },
        childCheckChange() {            
            const anyChildSelected = this.innerValue.children.reduce((acum, x) => acum || x.selected, false);
            this.innerValue.selected = anyChildSelected;
        },
    },
    computed: {
        haveNotChildrenSelected() {
            return this.innerValue?.children.length > 0 && !this.innerValue.selected;
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.innerValue = newValue;
            },
        },
        innerValue: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.$emit("input", newValue)
            }
        },
    }
}
</script>


<style scoped>
.impediment-option__container {
  display: flex;
}

.impediment-child-option__container {
    display: flex;
    align-items: center;
    margin-left: 15px;
}
</style>